import ProfileMenu from "@/components/app/Navigation/GlobalHeader/ProfileMenu";
import { Box, Stack } from "@mui/material";
import { Navbar } from "@trimble/modus-cmx";
import { pageLayout } from "@/theme/pageLayout";

function SuperAdminHeader() {
  return (
    <Box
      sx={{
        position: "relative",
        "& .logo": {
          cursor: "default",
        },
      }}
    >
      <Navbar
        logoName="subscriptions"
        centered
        userCard={{ email: "", name: "" }}
        visibility={{}} // Keeps default user button disabled as we use our own
      />
      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        sx={{
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: 1,
          right: {
            xs: pageLayout.px.xs,
            md: pageLayout.px.md,
            lg: `calc((100% - ${pageLayout.width.lg}) / 2)`,
            xl: `calc((100% - ${pageLayout.width.xl}) / 2)`,
          },
        }}
      >
        <ProfileMenu />
      </Stack>
    </Box>
  );
}

export default SuperAdminHeader;
